import { useState, useEffect } from "react";
import { api } from "@/lib/api";

export default function EmailPreview() {
  const [data, setData] = useState(null);
  const [active, setActive] = useState(0);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/admin/email-previews").then(({ data }) => setData(data)).finally(() => setLoaded(true));
  }, []);

  if (!loaded) return <p className="opacity-60 py-8 animate-pulse">Loading email previews...</p>;
  if (!data) return <p className="opacity-60 py-8 font-mono-ui text-sm text-[#FF2A00]">Could not load previews.</p>;

  const previews = data.previews || [];
  const current = previews[active];
  const sender = data.sender || {};

  return (
    <div data-testid="emails-panel">
      {/* Sender info */}
      <div className="border-2 border-[#F2EFEB]/40 p-4 mb-6">
        <p className="overline text-[#DFFF00] mb-2">Sender</p>
        <div className="font-mono-ui text-xs space-y-1">
          <p><span className="opacity-50">From name:</span> {sender.from_name || "—"}</p>
          <p><span className="opacity-50">Reply-to:</span> {sender.reply_to || "not set (replies go to the managed inbox)"}</p>
          <p>
            <span className="opacity-50">Delivery:</span>{" "}
            <span className={sender.delivery_enabled ? "text-[#DFFF00]" : "text-[#FF2A00]"}>
              {sender.delivery_enabled ? "Active (Emergent-managed Resend)" : "Disabled — no email key configured"}
            </span>
          </p>
        </div>
        <p className="font-mono-ui text-[0.65rem] opacity-50 mt-3">
          This is a live preview of the exact HTML each email uses — nothing is sent. Order previews use sample line items.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-[280px_1fr] gap-6">
        {/* List */}
        <div className="space-y-2" data-testid="email-list">
          {previews.map((p, i) => (
            <button
              key={p.id}
              onClick={() => setActive(i)}
              data-testid={`email-tab-${p.id}`}
              className={`w-full text-left border-2 p-3 transition-colors ${
                i === active ? "border-[#DFFF00] bg-[#DFFF00] text-[#090909]" : "border-[#F2EFEB]/40 hover:border-[#F2EFEB]"
              }`}
            >
              <p className="uppercase text-sm tracking-wide">{p.label}</p>
              <p className={`font-mono-ui text-[0.65rem] mt-1 ${i === active ? "text-[#090909]/70" : "opacity-50"}`}>{p.trigger}</p>
            </button>
          ))}
        </div>

        {/* Preview */}
        <div data-testid="email-preview-pane">
          <div className="border-2 border-[#F2EFEB]/40 p-3 mb-3">
            <p className="font-mono-ui text-[0.65rem] opacity-50 uppercase tracking-widest">Subject</p>
            <p className="text-sm" data-testid="email-subject">{current?.subject}</p>
            <p className="font-mono-ui text-xs opacity-60 mt-2">{current?.description}</p>
          </div>
          <div className="border-2 border-[#F2EFEB]/40 bg-[#F2EFEB]">
            <iframe
              key={current?.id}
              title={current?.label}
              srcDoc={current?.html}
              data-testid="email-iframe"
              className="w-full h-[600px] block"
              sandbox=""
            />
          </div>
        </div>
      </div>
    </div>
  );
}
